import React, { useEffect, useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import AuthContext from "../../Context/AuthContext";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import EvaluationStatus from "../Components/EvaluationStatus";
import EvaluationStatusObjectives from "../Components/EvaluationStatusObjectives";
import PendingEvaluation from "../Components/PendingEvaluation";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Carousel from "react-bootstrap/Carousel";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import PulseStep from "../../Client/Components/PulseStep";
import ThankyouStep from "../../Client/Components/ThankyouStep";
import PraiseElement from "../Components/PraiseElement";
import BirthdayUser from "../Components/BirthdayUser";
import { Wizard } from "react-use-wizard";
import { useTranslation } from "react-i18next";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./Dashboard.css";

function Dashboard() {
  const [isLoading, setIsLoading] = useState(true);
  const [evaluations, setEvaluations] = useState([]);
  const [pendingEvaluations, setPendingEvaluations] = useState([]);
  const [steps, setSteps] = useState([]);
  const [praises, setPraises] = useState([]);
  const [index, setIndex] = useState(0);
  const [indexBirthdays, setIndexBirthdays] = useState(0);
  const [users, setUsers] = useState([]);

  const { state, signout } = useContext(AuthContext);

  const location = useLocation();

  const { t } = useTranslation();

  Chart.register(ChartDataLabels);

  useEffect(() => {
    async function fetch() {
      try {
        const storedData = JSON.parse(localStorage.getItem("UserData"));

        const queryResponse = await axios({
          method: "get",
          url: `${process.env.REACT_APP_BACKEND_URL}/users/me/${state.userId}`,
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });

        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_BACKEND_URL}/periods/dashboard/${state.userId}`,
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });

        const fetchResponse = await axios({
          method: "get",
          url: `${process.env.REACT_APP_BACKEND_URL}/users/birthdays/team/${state.userId}`,
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });

        const result = await axios({
          method: "get",
          url: `${process.env.REACT_APP_BACKEND_URL}/periods/dashboard/pending/${state.organization}`,
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });
        const query = await axios({
          method: "post",
          url: `${process.env.REACT_APP_BACKEND_URL}/pulseQuestionnaireEvaluations/evaluation`,
          data: { userId: state.userId },
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });
        const queryResult = await axios({
          method: "get",
          url: `${process.env.REACT_APP_BACKEND_URL}/praises/organization/${state.organization}`,
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });
        setEvaluations(response.data.evaluations);
        setPendingEvaluations(result.data.pendingEvaluations);
        setSteps(query.data.steps);
        setPraises(queryResult.data.praises);
        setUsers(fetchResponse.data.users);

        if (
          (storedData &&
            (storedData.performancePackage === null ||
              storedData.strategyPackage === null ||
              storedData.performancePackage === undefined ||
              storedData.strategyPackage === undefined)) ||
          (storedData &&
            (storedData.performancePackage !==
              queryResponse.data.performancePackage ||
              storedData.strategyPackage !==
                queryResponse.data.strategyPackage ||
              storedData.role !== queryResponse.data.role))
        ) {
          signout();
        }
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        if (error.response.status === 401) {
          signout();
        }
      }
    }
    fetch();
  }, [
    location.key,
    signout,
    state.token,
    state.userId,
    state.organization,
    state.performancePackage,
    state.strategyPackage,
  ]);

  const handleRadioClick = (id, value) => {
    let step = steps.find((element) => element.id === id);
    step.value = value;
    addStep(step);
  };

  const addStep = async (step) => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/pulseQuestionnaireEvaluations/step/addStep`,
        data: {
          step: step,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  if (isLoading === true) {
    return (
      <Container fluid>
        <Row className="justify-content-center align-items-center">
          <Col className="center">
            <Spinner animation="border" />
          </Col>
        </Row>
      </Container>
    );
  } else {
    return (
      <Container fluid>
        {(state.role === "admin" ||
          state.role === "root" ||
          state.role === "owner") &&
        pendingEvaluations.length > 0 ? (
          <Row className="mb-4">
            {pendingEvaluations.map((item) => {
              if (
                item.type === "competencias" ||
                item.type === "encuestas" ||
                item.type === "nom035"
              ) {
                return (
                  <EvaluationStatus
                    key={item.periodId}
                    data={[
                      item.totalResponses - item.answeredResponses,
                      item.answeredResponses,
                    ]}
                    periodId={item.periodId}
                    periodName={item.title}
                    periodName_english={item.title_english}
                    type={item.type}
                    role={state.role}
                    language={state.language}
                  />
                );
              } else {
                return (
                  <EvaluationStatusObjectives
                    key={item.periodId}
                    data={[
                      item.createObjectivesResponses,
                      item.inReviewResponses,
                      item.inProgressResponses,
                      item.firstApprovalResponses,
                      item.secondApprovalResponses,
                      item.finishedResponses,
                      item.closedResponses,
                    ]}
                    periodId={item.periodId}
                    periodName={item.title}
                    periodName_english={item.title_english}
                    role={state.role}
                    language={state.language}
                  />
                );
              }
            })}
          </Row>
        ) : (
          <Row>
            <></>
          </Row>
        )}
        {steps.length > 0 ? (
          <Row className="justify-content-center">
            <Col lg={9} className="mb-5 mt-5">
              <Wizard>
                {steps.map((element) => (
                  <PulseStep
                    key={element.id}
                    id={element.id}
                    question={element.description}
                    question_english={element.description_english}
                    answers={element.answers}
                    handleRadioClick={handleRadioClick}
                    value={element.value}
                    required={element.required}
                    language={state.language}
                  />
                ))}
                <ThankyouStep language={state.language} />
              </Wizard>
            </Col>
          </Row>
        ) : (
          <></>
        )}
        {users.length > 0 ? (
          <Row className="mt-5 mb-5">
            <h2 className="mb-4 text-center praises-dashboard-title">
              Próximos cumpleaños
            </h2>
            <Carousel
              activeIndex={indexBirthdays}
              onSelect={(selectedIndex) => setIndexBirthdays(selectedIndex)}
              controls={true}
              indicators={false}
              nextIcon={
                <span aria-hidden="true">
                  <FaChevronRight style={{ fontSize: 20 }} />
                </span>
              }
              prevIcon={
                <span aria-hidden="true">
                  <FaChevronLeft style={{ fontSize: 20 }} />
                </span>
              }
            >
              {users.map((item) => (
                <Carousel.Item key={item._id}>
                  <Row className="justify-content-center mb-4">
                    {item.map((element) => (
                      <BirthdayUser
                        key={element._id}
                        id={element._id}
                        firstName={element.firstName}
                        lastName={element.lastName}
                        profilePicture={element.profilePicture}
                        language={state.language}
                        profileName={element.profileName}
                        profileNameEnglish={element.profileNameEnglish}
                        birthDate={element.birthDate}
                      />
                    ))}
                  </Row>
                </Carousel.Item>
              ))}
            </Carousel>
          </Row>
        ) : (
          <></>
        )}
        {praises.length > 0 ? (
          <Row className="mt-5 mb-5">
            <h2 className="mb-4 text-center praises-dashboard-title">
              {t("Dashboard.Reconocimientos.Titulo")}
            </h2>
            <Carousel
              activeIndex={index}
              onSelect={handleSelect}
              controls={true}
              indicators={false}
              nextIcon={
                <span aria-hidden="true">
                  <FaChevronRight style={{ fontSize: 20 }} />
                </span>
              }
              prevIcon={
                <span aria-hidden="true">
                  <FaChevronLeft style={{ fontSize: 20 }} />
                </span>
              }
            >
              {praises.map((item) => (
                <Carousel.Item key={item._id}>
                  <Row className="justify-content-center mb-4">
                    {item.map((element) => (
                      <PraiseElement
                        key={element._id}
                        id={element._id}
                        title={element.title}
                        receiverName={element.receiverName}
                        receiverProfilePicture={element.receiverProfilePicture}
                        senderId={element.senderId}
                        senderName={element.senderName}
                        senderProfilePicture={element.senderProfilePicture}
                        message={element.message}
                        values={element.values}
                        url={element.url}
                        userId={state.userId}
                        language={state.language}
                      />
                    ))}
                  </Row>
                </Carousel.Item>
              ))}
            </Carousel>
          </Row>
        ) : (
          <></>
        )}
        {evaluations.length > 0 ? (
          <Row className="mt-5 mb-5">
            {evaluations.map((item) => (
              <PendingEvaluation
                key={item._id}
                id={item._id}
                periodName={item.periodName}
                periodName_english={item.periodName_english}
                start_date={item.start_date}
                end_date={item.end_date}
                type={item.type}
                status={item.status}
                path={item.path}
                user={item.user}
                language={state.language}
              />
            ))}
          </Row>
        ) : (
          <Row className="mt-5 mb-5">
            <Col className="mb-4 mt-4">
              <h2 className="text-center no-eval">
                {t("Dashboard.EvaluacionesPendientes.NoTienes")}
              </h2>
            </Col>
          </Row>
        )}
      </Container>
    );
  }
}

export default Dashboard;
